import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { ContextService } from '../../services/context/context.service';
import { DataService } from '../../services/context/data.service';
import { UIStateService } from '../../services/context/uistate.service';
import { AppMonitoringService } from '../../services/util/app-monitoring.service';
import * as fromModel from '../../services/models';
import { RefDataService } from '../../services/context/ref-data.service';
import { Utils } from '../../../utils/utils';
import { EditExpenseComponent } from '../edit-expense/edit-expense.component';
import { DeleteConfirmationComponent } from '../../context-components/delete-confirmation/delete-confirmation.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'gp-expense-summary',
  templateUrl: './expense-summary.component.html',
  styleUrls: ['./expense-summary.component.scss']
})
export class ExpenseSummaryComponent implements OnInit, OnChanges, OnDestroy {

  @Output() Save: EventEmitter<any> = new EventEmitter();
  @Output() UpdateExpense: EventEmitter<any> = new EventEmitter();
  @Input('GoalId') goalId: string;
  @Input("Refresh") refresh: string;
  
  
  protected _storeDataSubscription: Subscription;
  
  Expenses: fromModel.Expense[]; 
  expenses = [];       

  expenseTypeMenuItems;
  isDataChanged = false;

  constructor(
    private contextService:ContextService,
    private refDataService: RefDataService,
    private dataService:DataService,
    private uiStateService: UIStateService,
    private dialog: MatDialog, 
    private appMonitoringService: AppMonitoringService) {      
  }

  ngOnInit(): void {
    this._storeDataSubscription = this.dataService.subscribe((appData: fromModel.IAppData) => this.populateAppData(appData));   
    this.prepareExpenseMenu();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.isDataChanged = false; 
    this.expenses = [];
    this.populatExpenses();      
  }

  private populateAppData(appData: fromModel.IAppData){
    this.Expenses = [];
    if(appData && appData.action!==fromModel.DATA_ACTION.NONE){      
      this.populatExpenses();
    }
  }

  populatExpenses(){
    
    let expId;
    let expTypeDesc;
    let expDesc;
    //let ownerName;
    let start;
    let end;
    let amount;
    let isIncluded;   
    

    this.Expenses = this.dataService.getAllExpensesByGoalId(this.goalId);
      this.Expenses.forEach(exp => {
        expId = exp.expId;
        expDesc = exp.expDesc;
        isIncluded = exp.isIncluded;
        

        expTypeDesc = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.Expenses, exp.expType).value;
        //ownerName = this.dataService.getPlanClientByClientId(exp.owner).clientname;
        
        if(exp.amtPeriod[0].startType === fromModel.AMOUNTPERIODTYPE.Year){
          start = exp.amtPeriod[0].startYr;
        } else if(exp.amtPeriod[0].startType === fromModel.AMOUNTPERIODTYPE.Age){
          start = Utils.getYearByAge(this.dataService.getPlanClientByClientId(exp.owner).age, exp.amtPeriod[0].startAge);
        } else if(exp.amtPeriod[0].startType === fromModel.AMOUNTPERIODTYPE.AtRet){
          start = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.StartType, exp.amtPeriod[0].startType).value;
        } else if(exp.amtPeriod[0].startType === fromModel.AMOUNTPERIODTYPE.AtEnd){
          start = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.StartType, exp.amtPeriod[0].startType).value;
        }

        if(exp.amtPeriod[0].endType === fromModel.AMOUNTPERIODTYPE.Year){
          end = exp.amtPeriod[0].endYr;
        } else if(exp.amtPeriod[0].endType === fromModel.AMOUNTPERIODTYPE.Age){
          end = Utils.getYearByAge(this.dataService.getPlanClientByClientId(exp.owner).age, exp.amtPeriod[0].endAge);
        } else if(exp.amtPeriod[0].endType === fromModel.AMOUNTPERIODTYPE.AtRet){
          end = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.StartType, exp.amtPeriod[0].endType).value;
        } else if(exp.amtPeriod[0].endType === fromModel.AMOUNTPERIODTYPE.AtEnd){
          end = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.StartType, exp.amtPeriod[0].endType).value;
        } else if(exp.amtPeriod[0].endType === fromModel.AMOUNTPERIODTYPE.Duration){
          end = `for ${exp.amtPeriod[0].duration} years`; 
        }
        amount = exp.amtPeriod[0].amount;
       // inc.growthTypeDesc = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.GrowthRates, inc.growthType).value;

        // Updating expense in this.expense object if Expense is updated
        const tempExp = this.expenses.find(_exp=>_exp.expId === expId);
        if(tempExp){
          tempExp.expDesc = expDesc;
          tempExp.expTypeDesc = expTypeDesc;
          //tempExp.ownerName = ownerName;
          tempExp.start = start;
          tempExp.end = end;
          tempExp.amount = amount;
        } else {
            this.expenses.push({expId: expId, expDesc: expDesc, expTypeDesc: expTypeDesc, 
            start: start, end:end, amount: amount, isIncluded: isIncluded });
        }
    });

    // Removing expense from this.expense object if Expense is  deleted
    let expPos;
    this.expenses.forEach(exp => {
      const _exp = this.Expenses.find(expense=>expense.expId === exp.expId);
      if(!_exp){
        expPos = this.expenses.indexOf(exp);
      }
    });
    if(expPos>-1){
      this.expenses.splice(expPos, 1); 
    } 
  }

  prepareExpenseMenu(){   
    this.expenseTypeMenuItems = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.Expenses);
  }

  addExpense(expenseType){
    this.openModelDialog(fromModel.OPENDIALOGACTIONS.ADDEXPENSE, expenseType)
  }

  editExpense(expenseId){
    this.openModelDialog(fromModel.OPENDIALOGACTIONS.EDITEXPENSE, expenseId)
  }

  deleteExpense(expenseId, expenseDesc){
    this.openModelDialog(fromModel.OPENDIALOGACTIONS.DELETEEXPENSE,expenseId,expenseDesc);    
  }

  selectExpense(expenseId){  
    let expense = this.expenses.find(exp=> exp.expId === expenseId);
    if(expense){
      expense.isIncluded = !expense.isIncluded;
      this.isDataChanged = true;
    }
  }

  saveSelectedExpenses(event) { 
    event.stopImmediatePropagation();
    //event.bubbles = false;   
    let selectedExpenses = [];
    this.expenses.forEach(exp => {
      if(exp.isIncluded){
        selectedExpenses.push(exp.expId)
      }
    });    
    this.dataService.dispatchAction(fromModel.DATA_ACTION.SELECTEDEXPENSES, "ExpenseSummaryComponent-saveSelectedExpenses", {expenses: selectedExpenses, goalId: this.goalId});  
    this.dataService.savePlan();    
    //this.Save.emit();
  }
  
  openModelDialog(action: fromModel.OPENDIALOGACTIONS, parm1?: string, parm2?: string){
    switch(action){
      case fromModel.OPENDIALOGACTIONS.ADDEXPENSE: {
        let _goalId;
        if(!this.goalId){
          _goalId = 0;
        } else {
          _goalId = this.goalId;
        }
        const dialogRef = this.dialog.open(EditExpenseComponent, {
        width: '70%',
        height: '70%',
        data: {expType: parm1, goalId: _goalId},
        //data: expense,
        disableClose: true    
        }).afterClosed()
        .subscribe(result => {
          if(result && result.isSaved && result.expense && result.expense.isIncluded){
            //this.refreshExpense(result.expense);              
            this.UpdateExpense.emit();
          }
        });        
      break;
    }
      case fromModel.OPENDIALOGACTIONS.EDITEXPENSE: {
          let _goalId;
          if(!this.goalId){
            _goalId = 0;
          } else {
            _goalId = this.goalId;
          }
          const dialogRef = this.dialog.open(EditExpenseComponent, {
          width: '70%',
          height: '70%',
          data: {expenseId: parm1},
          //data: expense,
          disableClose: true    
          }).afterClosed()
          .subscribe(result => {
            if(result && result.isSaved && result.expense && result.expense.isIncluded){
              //this.refreshExpense(result.expense);              
              this.UpdateExpense.emit();
            }
          });        
        break;
      }
      case fromModel.OPENDIALOGACTIONS.DELETEEXPENSE: {
        const dialogRef = this.dialog.open(DeleteConfirmationComponent, {
          width: '500px',
          height: '240px',
          data: { deleteType: fromModel.DELETETYPE.Expense, name: parm2}                  
        }).afterClosed()
        .subscribe(isDeleted => {
          if(isDeleted){
            let exp = this.dataService.getExpenseByExpenseId(parm1);
            let goal = this.dataService.getGoalByExpenseId(parm1);
            this.dataService.dispatchAction(fromModel.DATA_ACTION.DELETEEXPENSE, "EditExpenseComponent-deleteExpense", {expense: exp, goalId: goal.goalId});
            this.dataService.savePlan();
            this.UpdateExpense.emit();         
          }
        });
        break;
      }       
    }
  }  

  ngOnDestroy(): void{
    if(this._storeDataSubscription && this._storeDataSubscription !== null){
      this._storeDataSubscription.unsubscribe();
    }        
  }
}
